import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbar,
} from "@mui/x-data-grid";
import React, { useState, useEffect, useContext } from "react";
import "./BillingPayment.scss";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../login/AccessToken";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MailIcon from "@mui/icons-material/Mail";
import Drawer from "@mui/material/Drawer";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import StagingArea from "./StagingArea";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { makeStyles } from "@material-ui/core/styles";
import { makeStyles } from "@mui/styles";
import { Card, Grid, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Navlogo from "../../assets/images/logo/NavLogo.png";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";
import showConfirmDialog from "../../components/ShowConfirmDialog/ShowConfirmDialog";
import SideNavbar from "./SideNavbar";
import NoDataPage from "./NoDataPage";
import { BrandingContext } from "../../BrandingProvider";
import FooterPdfTemplate from "../Branding/FooterPdfTemplate";
import FooterPdfTemplateWithDept from "../Branding/FooterPdfTemplateWithDept";
import { Box } from "@mui/material";
import SaveAlt from "@mui/icons-material/SaveAlt";
import { CSVLink } from "react-csv";
import { displayPatientName } from "../../utils/displayPatientName";

import "jspdf-autotable";

const useStyles = makeStyles((theme) => ({
  pageSizeOptions: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "10px",
    // Add additional styles as needed
  },
}));
const Estimate = () => {
  const brandingData = useContext(BrandingContext);
  const classes = useStyles();
  const history = useHistory();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const handleAddItem = () => {
    history.push("/newEstimate");
  };
  const [facilityName, setFacilityName] = useState(
    sessionStorage.getItem("facility_name") || ""
  );
  const REACT_APP_SENDER_EMAIL = process.env.REACT_APP_SENDER_EMAIL;
  const [authToken, setAuthToken] = useState("");
  const [estimateList, setEstimateList] = useState([]);
  const [estimateSearchText, setEstimateSearchText] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedEstimate, setSelectedEstimate] = useState(null);
  const [pdfDataUri, setPdfDataUri] = useState(null);
  const [departments, setDepartments] = useState([]);
  const isEmailEnabled = sessionStorage.getItem("isEmailEnabled") !== "false";
  const handleSendMail = async (id) => {
    const message = `Are you sure you want to send this estimate via mail?`;
    const isConfirmed = await showConfirmDialog(message);

    if (isConfirmed) {
      const foundEstimate = estimateList.find(
        (estimate) => estimate.estimate_id === id
      );

      if (foundEstimate) {
        setSelectedEstimate(foundEstimate);
      } else {
        console.error(`Estimate with id ${id} not found in estimateList`);
      }
    } else {
      console.log("Sending email canceled");
    }
  };
  const fetchDepartments = async () => {
    try {
      const headers = { Authorization: `Bearer ${authToken}` };
      const response = await axios.get(
        `${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`,
        { headers }
      );
      setDepartments(response.data.department_list);
    } catch (error) {
      console.error("Error fetching departments", error);
    }
  };

  useEffect(() => {
    fetchDepartments(); // Fetch departments on component mount
  }, [authToken]);

  useEffect(() => {
    if (selectedEstimate) {
      generateAndDownloadPDF();
    }
  }, [selectedEstimate]);
  useEffect(() => {
    if (pdfDataUri) {
      sendEmail();
    }
  }, [pdfDataUri]);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };
  useEffect(() => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken") ?? "");
  }, []);
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  // const fetchEstimateList = () => {
  //   const requestData = {
  //     hip_id: facilityName,
  //   };
  //   if (authToken !== "") {
  //     axios
  //       .post(`${REACT_APP_BACKEND_ROUTE_URL}get_all_estimates/`, requestData, {
  //         headers: { Authorization: `Bearer ${authToken}` },
  //       })
  //       .then((res) => {
  //         if (res.data.status === "Success") {
  //           const activeEstimatesWithId = res.data.estimates
  //             .filter((estimate) => estimate.active)
  //             .map((estimate) => ({
  //               ...estimate,
  //               id: estimate.estimate_id,
  //               total: parseFloat(estimate.total_amount).toFixed(2),
  //             }));
  //           setEstimateList(activeEstimatesWithId);
  //         } else {
  //           toast.error("Error");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching estimate list:", error);
  //       });
  //   }
  // };

  const fetchEstimateList = () => {
    if (authToken !== "") {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_estimates/`, {
          headers: { Authorization: `Bearer ${authToken}` },
        })
        .then((res) => {
          if (res.data.status === "Success") {
            const activeEstimatesWithId = res.data.estimates
              .filter((estimate) => estimate.active)
              .map((estimate) => ({
                ...estimate,
                id: estimate.estimate_id,
                total: parseFloat(estimate.total_amount).toFixed(2),
              }))
              .sort(
                (a, b) => new Date(b.estimate_date) - new Date(a.estimate_date)
              ); // Sort by date in descending order

            setEstimateList(activeEstimatesWithId);
          } else {
            toast.error("Error");
          }
        })
        .catch((error) => {
          console.error("Error fetching estimate list:", error);
        });
    }
  };

  useEffect(() => {
    fetchEstimateList();
  }, [authToken]);

  const sendEmail = async () => {
    try {
      console.log("Preparing to send email...");
      let bannerBase64 = null;

      const bannerObject = brandingData.find(
        (item) => item.name === "email_banner" && item.type === "image"
      );

      if (bannerObject) {
        bannerBase64 = bannerObject.content; // Get the base64 content
      } else {
        console.error("Banner image not found in branding data");
        toast.error("Failed to find the banner image.");
        return;
      }

      const base64Data = pdfDataUri.split(",")[1];

      const emailData = {
        SUBJECT: "New Estimate Created Successfully",
        RECIPIENT: selectedEstimate.patient_email,
        SENDER: REACT_APP_SENDER_EMAIL,
        ATTACHMENT: [
          {
            FILE: base64Data,
            FILENAME: "attach.pdf",
          },
        ],
        TYPE: "ESTIMATE",
        BANNER: bannerBase64,
      };
      // if (
      //   sessionStorage.getItem("isEmailEnabled") === "true" &&
      //   selectedEstimate.patient_email
      // ) {
      //   const response = await axios.post(
      //     `${REACT_APP_BACKEND_ROUTE_URL}send_email/`,
      //     emailData,
      //     {
      //       headers: {
      //         Authorization: `Bearer ${authToken}`,
      //       },
      //     }
      //   );

      //   if (response.data.Status === "completed") {
      //     toast.success("Email Sent Successfully");
      //   } else {
      //     toast.error("Email not sent");
      //   }

      //   console.log("Email sent successfully", response.data);
      // } else {
      //   toast.error("Email service not activated for this license");
      // }
      if (sessionStorage.getItem("isEmailEnabled") !== "true") {
        toast.error("Email service not activated for this license");
      } else if (
        !selectedEstimate?.patient_email ||
        typeof selectedEstimate.patient_email !== "string" ||
        selectedEstimate.patient_email.trim() === ""
      ) {
        toast.error("Email not sent as patient's email address is unavailable");
      } else {
        try {
          const response = await axios.post(
            `${REACT_APP_BACKEND_ROUTE_URL}send_email/`,
            emailData,
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          );

          if (response.data.Status === "completed") {
            toast.success("Email Sent Successfully");
          } else {
            toast.error("Email not sent");
          }

          console.log("Email sent successfully", response.data);
        } catch (error) {
          console.error("Error sending email", error);
          toast.error("Error sending email. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error sending email", error);
      toast.error("An error occurred while sending the email.");
    }
  };

  const generateAndDownloadPDF = async () => {
    const input = document.getElementById("estimate-template");

    // Added scale to improve resolution and background to remove transparency issues
    html2canvas(input, {
      useCORS: true,
      allowTaint: true,
      scrollY: 0,
      backgroundColor: "#ffffff",
      scale: 2,
    }).then((canvas) => {
      const image = { type: "jpeg", quality: 0.98 };
      const margin = [0.5, 0.5];

      var imgWidth = 8.5;
      var pageHeight = 11;

      var innerPageWidth = imgWidth - margin[0] * 2;
      var innerPageHeight = pageHeight - margin[1] * 2;

      var pxFullHeight = canvas.height;
      var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
      var nPages = Math.ceil(pxFullHeight / pxPageHeight);

      var pageHeight = innerPageHeight;

      var pageCanvas = document.createElement("canvas");
      var pageCtx = pageCanvas.getContext("2d");
      pageCanvas.width = canvas.width;
      pageCanvas.height = pxPageHeight;

      var pdf = new jsPDF("p", "in", [8.5, 11]);

      for (var page = 0; page < nPages; page++) {
        if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
          pageCanvas.height = pxFullHeight % pxPageHeight;
          pageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
        }

        var w = pageCanvas.width;
        var h = pageCanvas.height;
        pageCtx.fillStyle = "white"; // Ensure a white background on each canvas page
        pageCtx.fillRect(0, 0, w, h);
        pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

        if (page > 0) pdf.addPage();
        var imgData = pageCanvas.toDataURL(
          "image/" + image.type,
          image.quality
        );
        pdf.addImage(
          imgData,
          image.type,
          margin[1],
          margin[0],
          innerPageWidth,
          pageHeight
        );
      }

      setPdfDataUri(pdf.output("datauri"));
      pdf.save(`Estimate.pdf`);
    });
  };

  const handleEdit = (id) => {
    // Find the selected estimate based on the id
    const selectedEstimate = estimateList.find(
      (estimate) => estimate.estimate_id === id
    );

    const subtotalsSum = selectedEstimate.items.reduce(
      (sum, item) => sum + parseFloat(item.subtotal),
      0
    );
    // Log the selected estimate and the entire estimateList to the console
    console.log("Selected Estimate:", selectedEstimate);
    console.log("Complete Estimate List:", estimateList);

    // Create a modified data object with both customer and customer_name
    const modifiedData = {
      ...selectedEstimate,
      subtotalSum: subtotalsSum,
      patient_id: selectedEstimate.patient_id, // Assuming customer_id is the patient_id
      name: selectedEstimate.patient_name, // Assuming name is the patient name
    };

    // Navigate to the edit page and pass the modified data in the location state
    history.push({
      pathname: `/editEstimate/${id}`,
      state: { data: modifiedData },
    });
  };

  const handleView = (id) => {
    const selectedEstimate = estimateList.find(
      (estimate) => estimate.id === id
    );

    if (selectedEstimate) {
      history.push({
        pathname: `/viewEstimate/${id}`,
        state: { data: selectedEstimate },
      });
    } else {
      console.error(`Estimate with id ${id} not found in estimateList`);
    }
  };

  const handleDelete = async (id) => {
    const message = `Are you sure you want to delete this estimate?`;
    const isConfirmed = await showConfirmDialog(message);

    if (isConfirmed) {
      console.log(`Deleting estimate with id: ${id}`);

      // Make an HTTP POST request for deletion
      const REACT_APP_BACKEND_ROUTE_URL =
        process.env.REACT_APP_BACKEND_ROUTE_URL;
      const headers = {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json", // Specify the content type as JSON
      };

      const requestData = {
        estimate_id: id,
      };

      const requestConfig = {
        headers: headers,
      };

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}delete_estimate/`,
          JSON.stringify(requestData),
          requestConfig
        )
        .then((res) => {
          console.log("Estimate deleted successfully!");
          if (res.data.status === "Success") {
            toast.success(res.data.message);
            fetchEstimateList();
          } else {
            toast.error("Error");
          }

          // Implement additional logic after successful deletion if needed
        })
        .catch((error) => {
          console.error("Error deleting estimate:", error);
          // Implement error handling logic
        });
    } else {
      console.log("Deletion canceled");
    }
  };

  const getRowClassName = (params) => {
    return "custom-row";
  };

  // Item Total (gross, pre-discount), total Discount in Rs (line-item discounts + bill-level
  // discount combined), and Net Payable (the authoritative, tax-inclusive backend total).
  const computeEstimateFinancials = (row) => {
    const items = row?.items || [];
    const itemTotal = items.reduce(
      (sum, item) => sum + (parseFloat(item.item_price) || 0) * (parseFloat(item.quantity) || 0),
      0
    );
    const netItemsTotal = items.reduce(
      (sum, item) => sum + (parseFloat(item.subtotal) || 0),
      0
    );
    const lineDiscountTotal = Math.max(itemTotal - netItemsTotal, 0);
    const billDiscountPercent = parseFloat(row?.discount) || 0;
    const billDiscountAmount = netItemsTotal * (billDiscountPercent / 100);
    const totalDiscount = lineDiscountTotal + billDiscountAmount;
    const netPayable = parseFloat(row?.total_amount) || 0;
    return { itemTotal, totalDiscount, netPayable };
  };
  //   const collateralImage =
  //     brandingData?.find((item) => item.name === "collateral_image.png")
  //       ?.content || null;
  //   const collateralBrandStatement =
  //     brandingData?.find((item) => item.name === "branding_statements.json")
  //       ?.content.collateralBrandStatement || null;
  //       const brandingItem = brandingData?.find((item) => item.name === "branding_statements.json");
  // const themeColour = brandingItem?.content?.themeColour || "#21cdc0"; // Extract themeColour

  // // Function to decode base64 to JSON
  // function decodeBase64ToJson(base64String) {
  //   try {
  //     // Decode base64 and parse the JSON string
  //     const jsonString = atob(base64String);
  //     return JSON.parse(jsonString);
  //   } catch (error) {
  //     console.error("Failed to decode base64 or parse JSON", error);
  //     return null;
  //   }
  // }

  // // Find the 'collateral_image.png'
  // const collateralImage =
  //   brandingData?.find((item) => item.name === "collateral_image.png")?.content || null;

  // // Find the 'branding_statements.json' and decode its base64 content
  // const brandingItem = brandingData?.find((item) => item.name === "branding_statements.json");
  // const brandingContent = brandingItem ? decodeBase64ToJson(brandingItem.content) : null;

  // // Extract the 'collateralBrandStatement' and 'themeColour' from decoded JSON
  // const collateralBrandStatement = brandingContent?.collateralBrandStatement || null;
  // const themeColour = brandingContent?.themeColour || "#21cdc0";

  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Extract the 'collateralBrandStatement' and 'themeColour' from JSON
  const collateralBrandStatement =
    brandingContent?.collateralBrandStatement || null;
  const themeColour = brandingContent?.themeColour || "#21cdc0";

  // Find the 'collateral_image.png' and get its base64 content directly
  const collateralImageItem = brandingData?.find(
    (item) => item.name === "collateral_image"
  );
  const collateralImage = collateralImageItem?.content || null;

  // Find the 'email_banner.png' and get its base64 content directly
  const emailBannerItem = brandingData?.find(
    (item) => item.name === "email_banner"
  );
  const emailBanner = emailBannerItem?.content || null;

  const generatePdf = () => {
    const doc = new jsPDF();

    // const tableColumns = [
    //   "ID",
    //   "Name",
    //   "Description",
    //   "Fee",
    //   "Added on",
    //   "Expiry date",
    //   "Status",
    // ];
    doc.autoTable({
      head: [["Estimate number", "Patient Name", "Estimate Date", "Item Total", "Discount (Rs)", "Net Payable"]],
      body: estimateList.map((estimate) => {
        const { itemTotal, totalDiscount, netPayable } = computeEstimateFinancials(estimate);
        return [
          estimate.estimate_number,
          displayPatientName(estimate.patient_name),
          estimate.estimate_date,
          itemTotal.toFixed(2),
          totalDiscount.toFixed(2),
          netPayable.toFixed(2),
        ];
      })
    });
    doc.save('Estimate_List.pdf');
  };

  const generateCsvData = () => {
    return estimateList.map((estimate) => {
      const { itemTotal, totalDiscount, netPayable } = computeEstimateFinancials(estimate);
      return {
        "Estimate number": estimate.estimate_number,
        "Patient Name": displayPatientName(estimate.patient_name),
        "Estimate Date": estimate.estimate_date,
        "Item Total": itemTotal.toFixed(2),
        "Discount (Rs)": totalDiscount.toFixed(2),
        "Net Payable": netPayable.toFixed(2),
      };
    });
  };

  const searchText = estimateSearchText.trim().toLowerCase();
  const filteredEstimates = searchText
    ? estimateList.filter(
      (estimate) =>
        String(estimate.patient_name || "").toLowerCase().includes(searchText) ||
        String(estimate.estimate_number || "").toLowerCase().includes(searchText)
    )
    : estimateList;

  return (
    <>
      <Tooltip title="Open Stageing Area">
        <Fab
          style={{
            color: "#fff",
            backgroundColor: "#0E3F66",
            overflow: "hidden",
            position: "fixed",
            bottom: 86,
            right: 16,
            marginRight: 1,
            borderRadius: "30px",
          }}
          color="primary"
          onClick={handleDrawerOpen}
        >
          <ArrowForwardIcon />
        </Fab>
      </Tooltip>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: { width: "40%" },
        }}
      >
        <div style={{ padding: "20px" }}>
          <Button onClick={handleDrawerClose} style={{ marginBottom: "10px" }}>
            <ArrowBackIcon />
          </Button>
          {drawerOpen && <StagingArea pathname="/newEstimate" />}
        </div>
      </Drawer>

      <SideNavbar />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr auto", // One column for text, one for button
          alignItems: "center",
          padding: "12px",
          gap: "20px", // Space between text and button
          marginBottom: "5px",
          // paddingX: { xs: 2, sm: 3 }, // Add padding for smaller screens
        }}
      >
        <p
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "left",
            color: "#172935",
            margin: 0, // Remove default margin to align properly
          }}
        >
          Estimates
        </p>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <TextField
            size="small"
            placeholder="Search by Name / Estimate No."
            value={estimateSearchText}
            onChange={(e) => setEstimateSearchText(e.target.value)}
            className="billing-search-field"
            sx={{
              minWidth: 280,
              "& .MuiOutlinedInput-root": {
                height: "42px",
                borderRadius: "10px",
              },
            }}
            InputProps={{
              startAdornment: (
                <SearchIcon sx={{ mr: 1, color: "text.secondary" }} />
              ),
            }}
          />
          <button
            onClick={handleAddItem}
            // variant="contained"
            // color="primary"
            type="button"
            className="btn btn__secondary btn__rounded btn__block billing-header-action-btn"
            style={{
              backgroundColor: "#0E3F66",
              borderRadius: "10px",
              fontSize: "14px",
              paddingX: { xs: 2, sm: 3 },
              paddingY: 1,
              textTransform: "none",
              height: "42px",
              // "&:hover": {
              //   backgroundColor: "#0C3555",
              // },
            }}
          >
            + Add Estimate
          </button>
        </Box>
      </Box>

      <div className="display-flex">
        {filteredEstimates !== undefined && filteredEstimates.length > 0 ? (
          <DataGrid
            rows={filteredEstimates}
            columns={[
              {
                field: "estimate_number",
                headerName: "Estimate Number",
                width: 200,
              },
              {
                field: "patient_name",
                headerName: "Patient Name",
                width: 160,
                renderCell: (params) => (
                  <span>
                    {displayPatientName(params.value)}
                    {params.row.is_walk_in_patient && (
                      <span style={{ color: "#9a3412", fontSize: "11px", marginLeft: "4px" }}>
                        (Walk-in)
                      </span>
                    )}
                  </span>
                ),
              },
              {
                field: "estimate_date",
                headerName: "Estimate Date",
                width: 160,
              },
              { field: "expiry_date", headerName: "Expiry Date", width: 160 },
              {
                field: "itemTotal",
                headerName: "Item Total",
                width: 130,
                valueGetter: (params) => computeEstimateFinancials(params.row).itemTotal,
                renderCell: (params) =>
                  `₹${computeEstimateFinancials(params.row).itemTotal.toFixed(2)}`,
              },
              {
                field: "discount",
                headerName: "Discount (₹)",
                width: 130,
                valueGetter: (params) => computeEstimateFinancials(params.row).totalDiscount,
                renderCell: (params) =>
                  `₹${computeEstimateFinancials(params.row).totalDiscount.toFixed(2)}`,
              },
              {
                field: "total_amount",
                headerName: "Net Payable",
                width: 140,
                valueGetter: (params) => computeEstimateFinancials(params.row).netPayable,
                renderCell: (params) =>
                  `₹${computeEstimateFinancials(params.row).netPayable.toFixed(2)}`,
              },
              {
                field: "actions",
                headerName: "Actions",
                headerAlign: "center",
                width: 120,
                sortable: false,
                renderCell: (params) => (
                  <div style={{ display: "flex", gap: "8px" }}>
                    <Tooltip title="Edit">
                      <EditIcon style={{ color: "#0D233F", fontSize: "18px", cursor: "pointer", display: "block", margin: "auto" }} onClick={() => handleEdit(params.row.estimate_id)} />
                    </Tooltip>
                    <Tooltip title="Delete">
                      <DeleteIcon style={{ color: "#0D233F", fontSize: "18px", cursor: "pointer", display: "block", margin: "auto" }} onClick={() => handleDelete(params.row.estimate_id)} />
                    </Tooltip>
                    <Tooltip title="View">
                      <VisibilityIcon style={{ color: "#0D233F", fontSize: "18px", cursor: "pointer", display: "block", margin: "auto" }} onClick={() => handleView(params.row.estimate_id)} />
                    </Tooltip>
                    <Tooltip title={isEmailEnabled ? "Send Mail" : "Email feature is disabled"}>
                      <MailIcon style={{ color: "#0D233F", fontSize: "18px", cursor: "pointer", display: "block", margin: "auto" }} onClick={() => handleSendMail(params.row.estimate_id)} />
                    </Tooltip>
                  </div>
                ),
              },
            ]}
            components={{
              Toolbar: () => (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    mb: 2,
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={8}
                    sx={{ display: "flex", gap: 1 }}
                  >
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                      display: "flex",
                      gap: 1,
                      justifyContent: { xs: "center", sm: "flex-end" },
                    }}
                  >
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => generatePdf()}
                      startIcon={<SaveAlt />}
                    >
                      Download PDF
                    </Button>
                    <CSVLink
                      data={generateCsvData()}
                      filename={"scan_share_records.csv"}
                      target="_blank"
                    >
                      <Button
                        variant="text"
                        color="primary"
                        startIcon={<SaveAlt />}
                      >
                        Download CSV
                      </Button>
                    </CSVLink>
                  </Grid>
                </Grid>
              ),
            }}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[5, 10]}
            getRowClassName={getRowClassName}
            sx={{
              "& .MuiDataGrid-root": {
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                fontFamily: "Arial, sans-serif",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#125386",
                color: "white",
                fontSize: "13px",
                fontWeight: "600",
                minHeight: "48px !important",
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: "white",
                  fontWeight: "600",
                  fontSize: "13px",
                },
                "& .MuiDataGrid-columnHeader": {
                  borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                  padding: "0 12px",
                },
                "& .MuiDataGrid-columnHeader:last-child": {
                  borderRight: "none",
                },
                "& .MuiDataGrid-iconButtonContainer": {
                  color: "white",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "white",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "white",
                },
                "& .MuiDataGrid-columnHeaderSortable": {
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                },
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                },
                "& .MuiSvgIcon-root": {
                  color: "white",
                },
              },
              "& .MuiDataGrid-row": {
                backgroundColor: "white",
                minHeight: "40px !important",
                "&:nth-of-type(even)": {
                  backgroundColor: "white",
                },
                "&:hover": {
                  backgroundColor: "#f8f9fa",
                },
                "&.Mui-selected": {
                  backgroundColor: "#e3f2fd",
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                  },
                },
                borderBottom: "1px solid #e0e0e0",
              },
              "& .MuiDataGrid-cell": {
                borderRight: "1px solid #e0e0e0",
                fontSize: "12px",
                color: "#374151",
                padding: "8px 12px",
                minHeight: "40px !important",
                "&:last-child": {
                  borderRight: "none",
                },
                "&:focus": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-cellContent": {
                fontSize: "12px",
                color: "#374151",
                fontWeight: "400",
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: "#f8f9fa",
                borderTop: "1px solid #e0e0e0",
                minHeight: "52px",
              },
              "& .MuiTablePagination-root": {
                color: "#374151",
                fontSize: "12px",
              },
              "& .MuiDataGrid-toolbarContainer": {
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e0e0e0",
                padding: "8px 16px",
              },
            }}
          />
        ) : (
          <NoDataPage />
        )}
      </div>

      <div
        id="estimate-template"
        style={{ position: "absolute", left: "-9999px" }}
      >
        {selectedEstimate ? (
          <Card style={{ height: "auto" }}>
            <Grid
              container
              style={{ backgroundColor: themeColour, padding: "20px" }}
            >
              <Grid item xs={6}>
                <Typography
                  variant="h4"
                  style={{ color: "black", fontWeight: "bold" }}
                >
                  ESTIMATE
                </Typography>
              </Grid>
              <Grid item xs={6} textAlign="left">
                {collateralImage && (
                  <img
                    src={`data:image/png;base64,${collateralImage}`}
                    alt="Collateral"
                    width="100px"
                    height="60px"
                    style={{ paddingBottom: "3px", paddingTop: "5px" }}
                  />
                )}
              </Grid>
            </Grid>

            <Grid container style={{ padding: "20px", marginTop: "10px" }}>
              <Grid item xs={6}>
                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                  Billed To
                </Typography>
                <Typography variant="subtitle1">
                  {displayPatientName(selectedEstimate.patient_name)}
                </Typography>
                <Typography variant="subtitle1">
                  {selectedEstimate.address}
                </Typography>
                <Typography variant="subtitle1">
                  {selectedEstimate.phone}
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ textAlign: "right" }}>
                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                  Estimate No: {selectedEstimate.estimate_number}
                </Typography>
                <Typography variant="subtitle1">
                  Date: {selectedEstimate.estimate_date}
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={12} style={{ padding: "20px" }}>
              <Grid
                container
                style={{
                  borderTop: "1px solid #ccc",
                  borderBottom: "1px solid #ccc",
                  padding: "10px",
                  fontWeight: "bold",
                }}
              >
                <Grid item xs={4}>
                  items
                </Grid>
                <Grid item xs={2}>
                  Unit Cost (₹)
                </Grid>
                <Grid item xs={2}>
                  Qty
                </Grid>
                <Grid item xs={2}>
                  Disc (%)
                </Grid>
                <Grid item xs={2}>
                  Amount (₹)
                </Grid>
              </Grid>

              {selectedEstimate.items.map((item, index) => (
                <Grid
                  container
                  key={index}
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "10px 0",
                  }}
                >
                  <Grid item xs={4}>
                    {item.item_name}
                  </Grid>
                  <Grid item xs={2}>
                    ₹{item.item_price}
                  </Grid>
                  <Grid item xs={2}>
                    {item.quantity}
                  </Grid>
                  <Grid item xs={2}>
                    {item.discount_percentage || 0}
                  </Grid>
                  <Grid item xs={2}>
                    ₹{item.subtotal}
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid container style={{ padding: "20px" }}>
              <Grid item xs={12} style={{ textAlign: "right" }}>
                {(() => {
                  const items = selectedEstimate.items || [];
                  const grossItemsTotal = items.reduce(
                    (sum, item) =>
                      sum + (parseFloat(item.item_price) || 0) * (parseFloat(item.quantity) || 0),
                    0
                  );
                  const netItemsTotal = items.reduce(
                    (sum, item) => sum + (parseFloat(item.subtotal) || 0),
                    0
                  );
                  const lineDiscountTotal = grossItemsTotal - netItemsTotal;
                  const billDiscountPercent = parseFloat(selectedEstimate.discount) || 0;
                  const billDiscountAmount = netItemsTotal * (billDiscountPercent / 100);
                  const taxPercent = parseFloat(selectedEstimate.tax) || 0;
                  const taxAmount = (netItemsTotal - billDiscountAmount) * (taxPercent / 100);
                  const grandTotal = parseFloat(selectedEstimate.total_amount) || 0;

                  return (
                    <>
                      {lineDiscountTotal > 0.004 && (
                        <>
                          <Typography variant="subtitle1">
                            Items Total: ₹{grossItemsTotal.toFixed(2)}
                          </Typography>
                          <Typography variant="subtitle1" style={{ color: "#2e7d32" }}>
                            Item Discounts: - ₹{lineDiscountTotal.toFixed(2)}
                          </Typography>
                        </>
                      )}
                      <Typography variant="subtitle1">
                        Subtotal: ₹{netItemsTotal.toFixed(2)}
                      </Typography>
                      {billDiscountPercent > 0 && (
                        <Typography variant="subtitle1" style={{ color: "#2e7d32" }}>
                          Bill Discount ({billDiscountPercent}%): - ₹{billDiscountAmount.toFixed(2)}
                        </Typography>
                      )}
                      {taxPercent > 0 && (
                        <Typography variant="subtitle1">
                          Tax ({taxPercent}%): + ₹{taxAmount.toFixed(2)}
                        </Typography>
                      )}
                      <Typography variant="h6" style={{ fontWeight: "bold" }}>
                        Total: ₹{grandTotal.toFixed(2)}
                      </Typography>
                    </>
                  );
                })()}
              </Grid>
            </Grid>
            <Grid container style={{ padding: "20px" }}>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Estimate Terms:
              </Typography>
              <Typography variant="subtitle1">
                Please pay your Estimate before {selectedEstimate.expiry_date}.
              </Typography>
            </Grid>

            <FooterPdfTemplateWithDept
              departments={departments}
              themeColour={themeColour}
            />
          </Card>
        ) : (
          <h1>No estimate selected</h1>
        )}
      </div>

    </>
  );
};

export default Estimate;
